module.exports = __webpack_public_path__ + "static/55d55b30-4c45-4a8f-9b24-c2d1ad4447d2-250.014f08dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/elephant-amber/55d55b30-4c45-4a8f-9b24-c2d1ad4447d2-250.jpg
// module id = 953
// module chunks = 168707334958949